<template>
    <div class="mainDraw">
        <div class="wheel_bg">
            <img src="@/assets/cashwheel/bg_light.png" alt="" class="rotating-bg">
        </div>
        <div class="mainDraw_bg">
            <img src="@/assets/cashwheel/wheel1.png" alt="">
            <div class="prize">
                <img ref="spinBgRef" src="@/assets/cashwheel/spinBg.png" alt="" class="spin-img">
                <img ref="prizeRef" src="@/assets/cashwheel/prize.png" alt="" class="spin-img">
                <div class="sector-wrapper">
                    <svg width="200" height="200" viewBox="0 0 215 215">
                        <path ref="sectorPath" d="M100,100 L60,17 A100,100 0 0,1 135.71,15.29 Z" fill="transparent"
                            stroke="white" class="sector-path hidden" stroke-width="6" />
                    </svg>
                </div>
            </div>
            <div class="lights">
                <img v-if="showLight1" src="@/assets/cashwheel/light1.png" alt="">
                <img v-else src="@/assets/cashwheel/light2.png" alt="">
            </div>
            <div class="pointer">
                <img src="@/assets/cashwheel/pointer.png" alt="">
            </div>

            <div class="draw" @click="clickSpinDraw">
                <img src="@/assets/cashwheel/draw.png" alt="">
            </div>
            <div class="draw_count">
                <img v-if="spinCount == 1" src="@/assets/cashwheel/num_1.png" alt="" @click="clickSpinDraw">
                <img v-if="spinCount == 0" src="@/assets/cashwheel/num_0.png" alt="">
            </div>
        </div>
    </div>

</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, defineEmits } from 'vue'

const showLight1 = ref(true)
let lightInterval: number

const prizeRef = ref<HTMLElement | null>(null)
const spinBgRef = ref<HTMLElement | null>(null)
const spinCount = ref(1);
let isSpinning = false
const emits = defineEmits(['showWinPopup'])
const TOTAL_PRIZES = 8

const clickSpinDraw = async () => {
    if (isSpinning) return
    isSpinning = true
    spinCount.value = 0;
    const selectedIndex = Math.floor(Math.random() * TOTAL_PRIZES)
    console.log('selectedIndex', selectedIndex);

    const degreesPerPrize = 360 / TOTAL_PRIZES
    const fullRotations = 5
    const finalAngle = (fullRotations * 360) - (degreesPerPrize * selectedIndex)

    const duration = 4000

    prizeRef.value?.style.setProperty('transition', `transform ${duration}ms ease-out`)
    spinBgRef.value?.style.setProperty('transition', `transform ${duration}ms ease-out`)

    prizeRef.value?.style.setProperty('transform', `rotate(${finalAngle}deg)`)
    spinBgRef.value?.style.setProperty('transform', `rotate(${finalAngle}deg)`)

    setTimeout(() => {
        isSpinning = false
        console.log(`Landed on prize index: ${selectedIndex}`)
        showSectorFlash()
    }, duration + 100)
}
const sectorPath = ref<SVGPathElement | null>(null)

const showSectorFlash = () => {
    const el = sectorPath.value
    if (!el) return

    el.classList.remove('hidden')
    el.classList.add('flashing')

    setTimeout(() => {
        el.classList.remove('flashing')
        el.classList.add('hidden')
        emits('showWinPopup')
    }, 3000)
}
onMounted(() => {
    lightInterval = window.setInterval(() => {
        showLight1.value = !showLight1.value
    }, 500)
})

onUnmounted(() => {
    clearInterval(lightInterval)
})

</script>
<style scoped>
.mainDraw {
    position: relative;
}

.wheel_bg img {
    width: 100%;
    position: absolute;
    margin-top: -70px;

}

.mainDraw_bg img {
    width: 100%;
    position: absolute;
}

.lights {
    position: relative;
    top: 100px;
    left: 20%;
}

.lights img {
    width: 60%;
}

.pointer img {
    width: 80px;
    position: absolute;
    top: 100px;
    left: 40%;
}

.prize img {
    width: 232px;
    position: absolute;
    top: 132px;
    left: 106px;
    transform-origin: center center;
    transition: transform 0.2s;
}

.spin-img {
    transform: rotate(0deg);
    transition: transform 0s;
    transform-origin: center center;
}

.draw img {
    width: 75px;
    position: absolute;
    top: 190px;
    left: 185px;
}

.draw_count img {
    width: 25px;
    position: absolute;
    top: 233px;
    left: 210px;
}

.rotating-bg {
    animation: rotateClockwise 10s linear infinite;
    transform: translateY(-50%);
}

.sector-wrapper {
    background-color: transparent;
    top: 120px;
    left: 105px;
    width: 200px;
    height: 200px;
    position: absolute;
}

@keyframes rotateClockwise {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

@keyframes flashStroke {

    0%,
    100% {
        stroke: transparent;
    }

    50% {
        stroke: white;
    }
}

.hidden {
    display: none;
}

.flashing {
    animation: flashStroke 0.5s ease-in-out infinite;
}

@media screen and (max-width: 768px) {
    .lights {
        top: 150px;
    }

    .pointer img {
        width: 95px;
        top: 140px;
        left: 41%;
    }

    .prize img {
        width: 51%;
        top: 175px;
        left: 139px;
    }

    .draw img {
        width: 85px;
        top: 260px;
        left: 245px;
    }

    .draw_count img {
        width: 30px;
        top: 307px;
        left: 272px;
    }

}

@media screen and (max-width: 400px) {
    .lights {
        top: 95px;
    }

    .pointer img {
        width: 70px;
        top: 85px;
        left: 40%;
    }

    .prize img {
        width: 51%;
        top: 112px;
        left: 91px;
    }

    .draw img {
        width: 55px;
        top: 165px;
        left: 160px;
    }

    .draw_count img {
        width: 20px;
        top: 194px;
        left: 177px;
    }
}
</style>